import { render, staticRenderFns } from "./SLAttributeEditorComponent.vue?vue&type=template&id=5780195d&scoped=true"
import script from "./SLAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./SLAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780195d",
  null
  
)

export default component.exports